import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 230px;
  height: 135px;
  background: transparent;
  border-radius: 10px;
  border: 1px solid var(--color-border);
  position: relative;
  display: flex;
  flex-direction: column;

  .title {
    color: var(--color-text-muted);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    text-transform: capitalize;
  }

  .content {
    padding: 20px 20px 4px;
  }

  .info {
    padding: 0 20px;

    .rate {
      color: var(--color-link);
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 27px */
    }
  }

  .description {
    padding: 8px 20px 0;
    color: var(--color-text-subtle);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 15.6px */
  }

  .dots-button {
    position: absolute;
    top: 20px;
    right: 10px;
    cursor: pointer;

    :hover {
      & svg {
        color: var(--color-accent);
      }
    }
  }
`;

export const SwitchWrapper = styled.span`
  display: block;
  margin: 0;
  text-align: center;
`;
